import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { Invoice } from '../domain/dtos/invoice'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetInvoice {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(id: string): Promise<Invoice> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_WEB_URL}/invoices/${id}`,
    })

    if (response.statusCode === HttpStatusCode.OK) {
      return response.data
    }

    if (response.statusCode === HttpStatusCode.FORBIDDEN) {
      throw new GeneralError('forbidden.invoice')
    }

    throw new GeneralError()
  }
}
